import { Component, ViewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { MatInput } from '@angular/material/input';

interface FileProperty {
  name: string;
  lastModified: number;
  size: number;
  mimeType: string;
  data: string;
}

@Component({
  selector: 'formly-file-type',
  template: `
    <div class="d-flex align-items-center">
      <div class="flex-grow-1">
        <input
          matInput
          [id]="id"
          type="text"
          [readonly]="true"
          [required]="to.required"
          [formControl]="formControl"
          [formlyAttributes]="field"
          [tabindex]="to.tabindex"
          [placeholder]="to.placeholder"
          [value]="formControl.value.name" />
        <input
          [id]="id + '_upload_file'"
          type="file"
          [accept]="to.accept"
          hidden
          (change)="onFileSelected($event)"
          #fileUpload />
      </div>
      <div class="ml-2 mt-1">
        <button
          mat-mini-fab
          [id]="id + '_upload_button'"
          type="button"
          color="primary"
          [disabled]="to.readonly"
          (click)="fileUpload.click()">
          <mat-icon>attach_file</mat-icon>
        </button>
      </div>
    </div>
  `,
})
export class FileTypeComponent extends FieldType<FieldTypeConfig> {
  @ViewChild(MatInput, { static: true }) formFieldControl!: MatInput;

  defaultOptions = {
    templateOptions: {
      accept: '.*',
    },
  };

  // TODO: find a solution to prevent scroll on focus
  onContainerClick() {}

  onFileSelected(event: any) {
    const reader = new FileReader();
    const file = event.target.files[0];

    reader.readAsDataURL(file);

    reader.onload = () => {
      this.formControl.markAsDirty();

      const fileData: FileProperty = {
        name: file.name,
        lastModified: file.lastModified,
        size: file.size,
        mimeType: file.type,
        data: reader.result.toString(),
      };

      this.formControl.patchValue(fileData);
      this.formControl.markAsTouched();
    };
  }
}
